import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { Observable, from } from 'rxjs';
import { Navigation, NavActionTypes, SideNavNavigation, CloseSideNav, MoveHome } from './nav.actions';
import { tap } from 'rxjs/operators';
import { Store, Action } from '@ngrx/store';
import { CoreState } from './_state.interfaces';
import { HOME_URL } from 'src/app/app.config';


@Injectable()
export class NavEffects {

  constructor(
    private actions$: Actions,
    private router: Router,
    private core: Store<CoreState>
  ) {}

  @Effect({dispatch: false})
  navigation$: Observable<Navigation> =
    this.actions$.pipe(
      ofType<Navigation>(NavActionTypes.Navigation),
      tap(act => {
        this.router.navigate([act.payload.url]);
      })
    );

    @Effect({dispatch: false})
    sideNavNavigation$: Observable<SideNavNavigation> =
      this.actions$.pipe(
        ofType<SideNavNavigation>(NavActionTypes.SideNavNavigation),
        tap(act => this.router.navigate([act.payload.url])),
        tap(() => this.core.dispatch(new CloseSideNav()))
      );

    @Effect({dispatch: false})
    moveHome$: Observable<Action> =
      this.actions$.pipe(
        ofType<MoveHome>(NavActionTypes.MoveHome),
        tap(() => this.router.navigate([HOME_URL]))
      );
}
